{
  "common": {
    "unassigned": "Sin Asignar",
    "notAvailable": "N/A",
    "untitled": "(Sin título)",
    "guest": "Invitado",
    "taskFallback": "Tarea",
    "team": "team",
    "currentTime": "Hora actual"
  },
  "actions": {
    "save": "guardar",
    "cancel": "cancelar",
    "delete": "borrar",
    "previous": "anterior",
    "next": "siguiente",
    "send": "Enviar",
    "create": "Crear"
  },
  "tabs": {
    "lista": "lista",
    "tablero": "tablero",
    "flow": "flow",
    "today": "Hoy",
    "week": "Sem",
    "month": "Mes",
    "threeMonths": "3M",
    "oneYear": "1A",
    "custom": "Custom"
  },
  "stages": {
    "planeada": "planeada",
    "en proceso": "en proceso",
    "synk": "synk",
    "check": "check",
    "retraso": "retraso",
    "bloqueo": "bloqueo",
    "done": "done"
  },
  "priority": {
    "baja": "baja",
    "media": "media",
    "alta": "alta"
  },
  "list": {
    "hideCompleted": "Ocultar completadas",
    "showCompleted": "Mostrar completadas"
  },
  "filter": {
    "savedAll": "Filtro guardado: Todos",
    "savedCount": "Filtro guardado: {{count}} usuario(s)"
  },
  "toolbar": {
    "searchPlaceholder": "buscar...",
    "searchAriaLabel": "Buscar tareas",
    "createButton": "Crear",
    "periodPrevious": "Período anterior",
    "periodNext": "Período siguiente"
  },
  "table": {
    "headers": {
      "stage": "etapa",
      "title": "título de la tarea",
      "date": "fecha",
      "time": "tiempo",
      "priority": "prioridad",
      "assignee": "encargado",
      "supervisor": "supervisor"
    },
    "markComplete": "Marcar \"{{title}}\" como completada",
    "stageOf": "Etapa de \"{{title}}\"",
    "priorityOf": "Prioridad de \"{{title}}\"",
    "recurrentTooltip": "Recurrente cada {{interval}} {{unit}}",
    "moreOptions": "Más opciones",
    "deleteConfirmTitle": "¿Borrar tarea?",
    "pagination": {
      "previous": "anterior",
      "next": "siguiente",
      "indicator": "página {{current}} de {{total}}"
    }
  },
  "kanban": {
    "dropHere": "suelta tareas aquí",
    "dateTag": {
      "today": "hoy",
      "oneDayAgo": "hace 1 día",
      "daysAgo": "hace {{count}} días",
      "oneWeekAgo": "hace una semana",
      "twoWeeksAgo": "hace dos semanas",
      "moreThanThreeWeeksAgo": "hace más de 3 sem",
      "inOneDay": "en 1 día",
      "inDays": "en {{count}} días",
      "inOneWeek": "en una semana",
      "inTwoWeeks": "en dos semanas"
    }
  },
  "flow": {
    "searchPlaceholder": "buscar en roadmap...",
    "searchAriaLabel": "Buscar en el roadmap",
    "noTasks": "No hay tareas",
    "noStage": "Sin etapa",
    "untitledNode": "Sin título",
    "weekLabel": "Semana {{number}}"
  },
  "empty": {
    "loadingTasks": "Cargando tareas del servidor relacional...",
    "loadingTimeline": "cargando timeline...",
    "noResults": "no hay resultados"
  },
  "duration": {
    "amountAria": "Cantidad de tiempo",
    "unitAria": "Unidad de tiempo",
    "units": {
      "minutos": "minutos",
      "horas": "horas",
      "días": "días",
      "semanas": "semanas"
    }
  },
  "userSelect": {
    "searchAria": "Buscar usuario",
    "searchPlaceholder": "buscar..."
  },
  "modal": {
    "close": "Cerrar",
    "titleAriaLabel": "Título de la tarea",
    "titlePlaceholder": "Nueva Tarea",
    "stageLabel": "etapa:",
    "stageAriaLabel": "Etapa de la tarea",
    "assigneeLabel": "encargado:",
    "supervisorLabel": "supervisor:",
    "dateLabel": "fecha:",
    "timeLabel": "tiempo:",
    "tagsLabel": "tags:",
    "addTagPlaceholder": "+",
    "addTagAriaLabel": "Agregar tag",
    "removeTagAriaLabel": "Quitar tag {{tag}}",
    "recurrenceLabel": "recurrente:",
    "recurrenceEvery": "cada {{interval}} {{unit}}",
    "recurrenceNone": "no",
    "recurrencePopoverTitle": "Configurar Recurrencia",
    "recurrenceEveryLabel": "cada",
    "recurrenceIntervalAria": "Intervalo de recurrencia",
    "recurrenceUnitAria": "Unidad de recurrencia",
    "recurrenceUnits": {
      "dias": "días",
      "weeks": "weeks",
      "meses": "meses",
      "años": "años"
    },
    "save": "Guardar",
    "findNextSlot": "Buscar siguiente horario disponible",
    "deleteTask": "Eliminar tarea",
    "deleteConfirm": "¿Seguro que quieres borrar esta tarea?",
    "descriptionAriaLabel": "Descripción de la tarea",
    "descriptionPlaceholder": "Añade una descripción sutil de buen gusto...",
    "nextTasks": "siguientes tareas",
    "subtaskBackAria": "Regresar al paso anterior",
    "subtaskAssistantAria": "Asistente para crear subtarea",
    "subtaskTitleRequired": "El título es obligatorio",
    "subtaskPlaceholders": {
      "title": "Escribe una tarea y presiona Enter...",
      "description": "Descripcion.. enter..",
      "assignee": "Asigna a un encargado (ej. beeto) y presiona Enter...",
      "duration": "Selecciona la duración en minutos (ej. 15, 30, 60) y presiona Enter...",
      "supervisor": "Asigna a un supervisor (opcional) y presiona Enter..."
    },
    "startTime": "hora de inicio",
    "monthPrev": "Mes anterior",
    "monthNext": "Mes siguiente",
    "reminderDateRequired": "Elige una fecha",
    "reminderUsersRequired": "Elige al menos un usuario",
    "monthNames": ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    "monthNamesShort": ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    "weekDaysShort": ["lu", "ma", "mi", "ju", "vi", "sá", "do"],
    "share": "Compartir",
    "shareAriaLabel": "Compartir tarea",
    "shareTitle": "Compartir tarea",
    "shareLinkAriaLabel": "Enlace para compartir",
    "shareCopy": "Copiar",
    "shareCopied": "¡Copiado!",
    "shareWhatsapp": "WhatsApp",
    "shareTelegram": "Telegram",
    "shareEmail": "Correo",
    "shareEmailSubject": "Te comparto una tarea en Colonny",
    "shareMessage": "Te comparto esta tarea en Colonny: {{title}}",
    "standaloneForbiddenTitle": "No tienes acceso a esta tarea",
    "standaloneForbiddenBody": "Necesitas pertenecer al espacio \"{{spaceName}}\" para poder ver esta tarea.",
    "standaloneNotFoundTitle": "No encontramos esta tarea",
    "standaloneNotFoundBody": "Puede que ya no exista o que el enlace esté mal escrito.",
    "backToHome": "Volver al inicio"
  },
  "smartTags": {
    "priorityHigh": "Prioridad Alta",
    "bugReport": "Bug Report",
    "reviewNeeded": "Review Needed",
    "meeting": "Reunión 📅",
    "reminder": "Recordatorio ⏰",
    "documentation": "Documentación 📄",
    "presentations": "Presentaciones 📐",
    "survey": "Encuesta 🙋",
    "flow": "Flujo 🗡️"
  },
  "comments": {
    "tabs": {
      "info": "Info",
      "comentarios": "comentarios",
      "team": "team",
      "docs": "docs",
      "meets": "meets"
    },
    "noTeamMembers": "No hay miembros del equipo en esta conversación...",
    "noDocs": "No hay archivos o documentos...",
    "noMeets": "No hay reuniones agendadas...",
    "startConversation": "Comienza la conversación...",
    "deleteConfirm": "¿Segur@ que quieres eliminar este comentario?",
    "editAria": "Editar comentario",
    "saveAria": "Guardar comentario",
    "cancelEditAria": "Cancelar edición",
    "deleteAria": "Eliminar comentario",
    "delete": "Eliminar",
    "likeAria": "Me gusta",
    "unlikeAria": "Quitar me gusta",
    "addReminderTitle": "Agregar recordatorio a este comentario",
    "reminderTitle": "Recordatorio",
    "reminderCopyTitle": "Clic para copiar el enlace",
    "reminderDetailsTitle": "Detalles del Recordatorio",
    "reminderCalendar": "Calendario:",
    "reminderDate": "Fecha:",
    "reminderCopyHint": "Clic en el icono para copiar el enlace",
    "reminderUnknownCalendar": "Desconocido",
    "reminderSavedBadge": "Recordatorio guardado",
    "reminderDefaultTitle": "Recordatorio de comentario",
    "reminderEventDescription": "Recordatorio desde los comentarios de la tarea: {{title}}.",
    "searchUserPlaceholder": "buscar usuario...",
    "searchUserAria": "Buscar usuario para el recordatorio",
    "save": "guardar",
    "writePlaceholder": "Escribe un comentario o @menciona... arrastra un archivo.",
    "suggestionPlaceholder": "Escribe una sugerencia o recordatorio para esta actualización...",
    "suggestionBadge": "Sugerencia",
    "linkedTaskBadge": "Tarea vinculada",
    "suggestionModeBanner": "Modo sugerencia / mejora estructurada",
    "suggestionModeExit": "Volver a comentario normal",
    "attachFile": "Adjuntar archivo",
    "recordScreen": "Grabar pantalla",
    "send": "Enviar",
    "expandImage": "Expandir imagen",
    "formatToolbarAria": "Barra de formato",
    "headingAria": "Tipo de título",
    "headingParagraph": "Párrafo",
    "bold": "Negrita",
    "italic": "Itálica",
    "link": "Enlace",
    "linkPrompt": "Pega un enlace",
    "linkApply": "Aplicar",
    "bulletList": "Lista con viñetas",
    "orderedList": "Lista numerada",
    "checklist": "Checklist",
    "quote": "Cita",
    "codeBlock": "Bloque de código",
    "expandEditor": "Expandir a pantalla completa",
    "collapseEditor": "Volver al panel",
    "workspaceTitle": "Comentario",
    "authorUnavailable": "Autor no disponible",
    "creatorAction": "creó esta tarea",
    "titleChangeAction": "cambió el título: {{oldValue}} ➔ {{newValue}}",
    "descriptionChangeAction": "cambió la descripción de la tarea",
    "statusChangeAction": "cambió de estatus: {{oldValue}} ➔ {{newValue}}"
  },
  "image": {
    "closeAria": "Cerrar imagen",
    "expandedAlt": "Vista ampliada"
  },
  "errors": {
    "fileUploadFailed": "Error al subir archivo",
    "createTaskFailed": "No se pudo crear la tarea",
    "oldReminderNoEvent": "Este es un recordatorio antiguo o no tiene un evento asociado.",
    "linkCopied": "Enlace del evento copiado al portapapeles.",
    "copyFailed": "No se pudo copiar el enlace. URL: {{url}}",
    "eventUrlFallback": "URL del evento: {{url}}"
  },
  "sidebar": {
    "title": "tareas",
    "projectFallback": "Proyecto",
    "newProjectPlaceholder": "Nombre del proyecto...",
    "createNew": "crear nuevo",
    "filterSearchPlaceholder": "Buscar usuario para filtrar...",
    "clearSelection": "Limpiar selección",
    "selectAll": "Seleccionar todos",
    "tasksNav": "Tareas",
    "reportsSeparator": "reportes",
    "reporting": "reporting",
    "hitosSeparator": "hitos",
    "hitoTitlePlaceholder": "Título del hito...",
    "hitoDescPlaceholder": "Descripción (opcional)...",
    "loadingHitos": "Cargando hitos...",
    "noHitos": "No hay hitos activos",
    "newHito": "nuevo hito",
    "addHitoAria": "Agregar hito"
  },
  "workframe": {
    "index": {
      "title": "ÍNDICE",
      "searchPlaceholder": "Buscar en el índice...",
      "expandAll": "Desplegar todos los documentos y subdocumentos",
      "collapseAll": "Comprimir todo el índice",
      "loading": "Cargando índice...",
      "empty": "No hay documentos bajo esta estructura.",
      "createFirst": "Crear primer documento",
      "noMatches": "No se encontraron coincidencias para \"{{term}}\"",
      "addSubdoc": "Añadir subdocumento",
      "subdocPlaceholder": "Título del subdocumento...",
      "create": "Crear",
      "newDocDefault": "Nuevo documento",
      "untitled": "Sin título",
      "noSpace": "Sin espacio",
      "resizeHandle": "Arrastra para cambiar el ancho del índice",
      "positionUpdated": "Posición actualizada",
      "positionUpdateFailed": "No se pudo actualizar la posición",
      "widthSaved": "Ancho del índice guardado"
    },
    "doc": {
      "title": "DOCUMENTACIÓN",
      "collapse": "Contraer columna de documentación",
      "expand": "Expandir columna de documentación",
      "changeIcon": "Cambiar ícono del documento",
      "titlePlaceholder": "Título del documento...",
      "loading": "Cargando documento...",
      "placeholder": "Selecciona un documento del índice para ver y editar su documentación",
      "iconUpdated": "Ícono actualizado",
      "iconUpdateFailed": "Error al actualizar el ícono",
      "titleSaved": "Título guardado",
      "titleSaveFailed": "Error al guardar el título",
      "textSaved": "Texto guardado",
      "textSaveFailed": "Error al guardar el texto",
      "collapsed": "Documentación contraída",
      "expanded": "Documentación desplegada"
    },
    "bitacora": {
      "title": "BITÁCORA",
      "addUpdate": "Añadir actualización",
      "loading": "Cargando bitácora...",
      "empty": "No hay actualizaciones registradas aún.",
      "addFirst": "Añadir primera actualización",
      "untitledUpdate": "Actualización sin título",
      "docBadge": "Documento: {{title}}",
      "noTime": "Sin tiempo",
      "addSuggestion": "Añadir sugerencia / mejora estructurada",
      "suggestionFallback": "Sugerencia",
      "suggestionBy": "Sugerencia por {{name}}: {{snippet}}",
      "user": "Usuario"
    },
    "dropdown": {
      "tooltip": "Cuadros de trabajo",
      "title": "Cuadros de trabajo",
      "none": "Ninguno",
      "structurePrefix": "ESTRUCTURA:",
      "loading": "Cargando...",
      "updatesStructure": "Estructura de actualizaciones",
      "workframe": "Cuadro de trabajo",
      "linkToDoc": "Vincular a documento:",
      "docSearchPlaceholder": "Escribe el título del documento...",
      "loadingDocs": "Cargando documentos...",
      "noDocs": "No se encontraron documentos",
      "createFailed": "No se pudo crear el cuadro de trabajo"
    },
    "share": {
      "title": "Compartir documento estructurado",
      "close": "Cerrar",
      "noAccess": "Sin acceso al documento",
      "linkedDocFallback": "Documento vinculado",
      "message": "Etiquetaste a @{{name}} en esta tarea estructurada. No tiene permisos para consultar el documento \"{{title}}\". ¿Quieres invitarlo para que pueda colaborar y verlo en su panel?",
      "readOnly": "Solo lectura",
      "editor": "Editor colaborativo",
      "skip": "Omitir (mantener privado)",
      "grantFailed": "No se pudo compartir el documento",
      "granted": "Documento compartido con @{{name}}"
    }
  }
}
